document.addEventListener("DOMContentLoaded", () => {
  // Image Slides
  if (typeof Splide === "undefined") return;

  var main = new Splide("#product-main-slider", {
    type: "slide",
    perPage: 1,
    pagination: false,
    arrows: true,
    lazyLoad: "nearby",
    heightRatio: 1,
  });

  var thumbs = new Splide("#product-thumb-slider", {
    fixedWidth: 100,
    fixedHeight: 100,
    gap: 10,
    rewind: true,
    pagination: false,
    arrows: false,
    isNavigation: true,
    focus: "center",
    breakpoints: {
      768: {
        fixedWidth: 70,
        fixedHeight: 70,
      },
    },
  });

  main.sync(thumbs);
  thumbs.mount();
  main.mount();

  // ✅ FORCE bind zoom for single-image products
  setTimeout(() => {
    const slides = document.querySelectorAll(
      "#product-main-slider .splide__slide"
    );

    slides.forEach((slide) => {
      bindZoomToSlide(slide);
    });
  }, 0);

  /* Hover zoom logic */
  function bindZoomToSlide(slide) {
    var container = slide.querySelector(".zoom-container");
    if (!container) return;

    var img = container.querySelector("img");
    if (!img) return;

    var zoomSrc = img.getAttribute("data-zoom");
    if (!zoomSrc) return;

    container.onmousemove = function (e) {
      var rect = container.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = x + "% " + y + "%";
      img.style.transform = "scale(2)";
    };

    container.onmouseleave = function () {
      img.style.transformOrigin = "center";
      img.style.transform = "scale(1)";
    };
  }

  main.on("mounted", function () {
    main.Components.Elements.slides.forEach((slide) => {
      bindZoomToSlide(slide);
    });
  });

  main.on("active", function (slide) {
    bindZoomToSlide(slide.slide);
  });

  main.on("move", function () {
    var imgs = document.querySelectorAll("#product-main-slider img");
    imgs.forEach(function (img) {
      img.style.transform = "scale(1)";
      img.style.transformOrigin = "center";
    });
  });

  function selectImageByVariant(variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src)
      return;

    var targetSrc = variant.featured_image.src.split("?")[0].split("/").pop();

    var slides = document.querySelectorAll(
      "#product-main-slider .splide__slide img"
    );

    for (var i = 0; i < slides.length; i++) {
      var imgSrc = slides[i].src.split("?")[0];

      if (imgSrc.indexOf(targetSrc) !== -1) {
        main.go(i);
        break;
      }
    }
  }

  // Variant
  const picker = document.querySelector(".variant-picker");
  if (!picker) return;

  var priceEl = document.getElementById("product-price");
  const variantInput = document.getElementById("variant-id");

  const variantTitle = picker.querySelectorAll(".variant_title");
  const buttons = picker.querySelectorAll(".variant-swatch");

  let selectedOptions = [];

  function getVariantFromOptions() {
    return window.productVariants?.find((variant) =>
      variant.options.every((opt, index) => opt === selectedOptions[index])
    );
  }

  function updateOptionAvailability() {
    buttons.forEach((btn) => {
      const btnOptionIndex = Number(btn.dataset.optionIndex);
      const btnOptionValue = btn.dataset.optionValue;

      // Build a temporary option set
      const tempSelected = [...selectedOptions];
      tempSelected[btnOptionIndex] = btnOptionValue;

      // Check if ANY variant exists with this combination
      const isValid = window.productVariants.some((variant) =>
        variant.options.every((opt, idx) => {
          return tempSelected[idx] === undefined || opt === tempSelected[idx];
        })
      );

      btn.disabled = !isValid;
    });
  }

  function updateUI(variant) {
    if (!variant) return;

    variantInput.value = variant.id;
    history.replaceState({}, "", `?variant=${variant.id}`);

    variant.options.map((option, index) => {
      variantTitle.forEach((title) => {
        if (Number(title.dataset.optionIndex) === index) {
          title.textContent = option;
        }
      });
    });

    buttons.forEach((btn) => {
      btn.classList.toggle(
        "active",
        selectedOptions[btn.dataset.optionIndex] === btn.dataset.optionValue
      );
    });

    updatePriceForVariant(variant);

    let sizeInfo = "";
    if (window.variantSizeInfo) {
      window.variantSizeInfo.map((info) => {
        if (info.id === variant.id) {
          sizeInfo = info.size_info;
        }
      });
    }

    const pack = window.__PACK_OF;
    const pricePerPiece = (variant.price / pack / 100).toFixed(2);

    document.getElementById("size_info").innerHTML = `
    ${sizeInfo}<br>
    No of Pieces per Packet: ${pack} (1 Quantity = ${pack} pcs)<br>
    ${window.currency_symbol} ${pricePerPiece} per piece`;

    selectImageByVariant(variant);
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const index = Number(button.dataset.optionIndex);
      selectedOptions[index] = button.dataset.optionValue;

      updateOptionAvailability(); // ✅ ADD THIS

      const variant = getVariantFromOptions();
      updateUI(variant);
    });
  });

  // Initial state
  const initialVariant = window.productVariants.find(
    (v) => v.id == variantInput.value
  );

  if (initialVariant) {
    selectedOptions = [...initialVariant.options];
    updateOptionAvailability();
    updateUI(initialVariant);
  }

  // Quantity control wires (as before)
  var btnInc = document.getElementById("qty-increase");
  var btnDec = document.getElementById("qty-decrease");
  var quantityInput = document.getElementById("quantity");

  if (btnInc)
    btnInc.addEventListener("click", function () {
      if (quantityInput) {
        const value = parseInt(quantityInput.value || 1) + 1;
        quantityInput.value = value;
        updatePackOf(value);
      }
    });

  if (btnDec)
    btnDec.addEventListener("click", function () {
      if (quantityInput) {
        const value = Math.max(1, parseInt(quantityInput.value || 1) - 1);
        quantityInput.value = value;
        updatePackOf(value);
      }
    });

  quantityInput.addEventListener("change", (e) => {
    let value = e.target.value;

    // Setting the value to 1
    // If number is less than one or anything other than number
    if (Number(value) < 1) {
      value = 1;
      e.target.value = value;
    }

    updatePackOf(value);
  });

  function updatePackOf(value) {
    const quantity = window.__PACK_OF * value;

    if (quantity > 9999) pack_of.innerHTML = `(9999+ pcs)`;
    else pack_of.innerHTML = `(${quantity}pcs)`;
  }

  // formatted price helper
  function formatPriceForVariant(variant) {
    if (!variant) return "";
    return (variant.price / 100).toFixed(2);
  }

  function updatePriceForVariant(variant) {
    if (!priceEl) return;
    priceEl.textContent = formatPriceForVariant(variant);
  }
});
